<template>
    <v-row class="mobile-input">
        <div class="t-textarea">
            <v-textarea
                v-if="!value"
                v-model="content"
                :rows="2"
                solo
                @input="handleInput"
                :autofocus="true"
                :outlined="$vuetify.breakpoint.xsOnly"
                placeholder="Please, input text"
            />
        </div>
        <v-btn class="plus_button" @click="click">+</v-btn>
    </v-row>
</template>

<script>
    export default {
        name: 'MobileInput',
        props: ['value', 'click'],
        data () {
            return {
                content: this.value,
            }
        },        
        components: {

        },
        computed:{

        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.content)
            },
        },
}
</script>

<style lang="scss">
    .mobile-input{
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 10;
        margin-left: 0 !important;
        .t-textarea{
            flex-grow: 1;
            .v-text-field__details{
                display: none !important;
            } 
            .v-input__control{
                background: #fff;
            }            
            padding: 0;
            .v-input__slot{
                margin: 0;
                fieldset{
                    border-radius: 0;
                    border-right: 0;
                    border-left: 0;
                    border-bottom: 0;
                }
            }                     
        }
        .plus_button{
            height:var(--head-h) !important;
            min-width: 36px;
            padding: 0 12px !important;
            font-size: 30px;
            border-radius: 0;
            color: white !important;     
            background-color: #b9f3a6 !important;            
        }
    }
</style>